<script>
	import { onMount, getContext, onDestroy } from 'svelte'
	import { adminUpdateShopEntry, SingleItem } from '../AdminModule.svelte'
	import { storeRemainingStorage } from '../../../library/scripts/Store.svelte'
	import { slide } from 'svelte/transition'
	import { url, urlAdmin } from '../../../library/scripts/Setup.svelte'
	import { storeShowItem } from '../../../library/scripts/Store.svelte'
	import { get_username, get_file_size } from '../../../library/scripts/utils'
	import { getCookie } from '../../../library/scripts/cookie'
	import { styles } from '../../../library/scripts/styles'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')
	const fsX = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const color = globals.colorMain
	const colorError = globals.colorError
	const shadow = globals.boxShadow
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover

	const userID = getCookie('id')

	let products = []
	let categories = []

	//show single item
	let showItem
	const stoShowItem = storeShowItem.subscribe((value) => {
		showItem = value
	})
	let productName = null
	let properties = []

	let alertError = false
	let message = ''

	const delete_shop_entry = async (id) => {
		const deleteItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'delete_shop_entry',
				data: {
					id: id,
				},
			}),
		})
		const fileSize = get_file_size()
		fileSize.then((value) => {
			storeRemainingStorage.set(value)
		})

		storeShowItem.set(false)
		const dataResponse = await deleteItem.json()
		return dataResponse.fetch
	}

	const show_item = (id) => {
		storeShowItem.set(true)
		productName = id
		products.forEach((product) => {
			if (product.name === id) {
				properties = product.properties.split(',')
				if (typeof product.image === 'object') {
					const sessProducts = JSON.parse(sessionStorage.getItem('shop'))
					sessProducts.forEach((value) => {
						for (const entry in value) {
							if (value['name'] === id) product.image = value['image']
						}
					})
				}
			}
		})
	}

	const close_item = () => {
		storeShowItem.set(false)
		showItem = false
	}

	const reset_error = () => {
		alertError = false
		message = ''
	}

	const delete_item = (id) => {
		const deleteFromDb = delete_shop_entry(id)

		if (deleteFromDb) {
			const prod = JSON.parse(sessionStorage.getItem('shop'))
			const newProds = prod.filter((item) => {
				if (item.id != id) return item
			})

			adminUpdateShopEntry.set(JSON.stringify(newProds))
			sessionStorage.setItem('shop', JSON.stringify(newProds))
		}
	}

	const update_item = (item) => {
		let oldItems = sessionStorage.getItem('shop')
		oldItems = JSON.parse(oldItems)
		oldItems.forEach((om) => {
			if (om.name === item.name) {
				item.image = 'noimage'
				SingleItem.set(
					item.id +
						'~' +
						item.category +
						'~' +
						item.name +
						'~' +
						item.properties +
						'~' +
						item.descshort +
						'~' +
						item.desclong +
						'~' +
						item.image +
						'~' +
						item.price +
						'~' +
						item.stock +
						'~' +
						item.currency
				)
			}
		})
	}

	onMount(async () => {
		adminUpdateShopEntry.subscribe((value) => {
			products = JSON.parse(value)
			//reset categories
			if (products != null) {
				categories.length = 0
				products.forEach((item) => {
					if (!categories.includes(item.category)) categories = [...categories, item.category]
				})
			}
		})
	})

	onDestroy(() => {
		stoShowItem
		SingleItem.set(false)
	})
</script>

<div class="container">
	{#if !showItem}
		<div style="width:100%" transition:slide={{ duration: 500, delay: 600 }}>
			<div class="title" use:styles={{ fsX, color }}>ITEMS PREVIEW</div>
			<!-- no entry yet -->

			{#if products === null || products.length === 0}
				<div class="message error" use:styles={{ fsN, colorError }}>No entry yet</div>
			{:else}
				{#each categories as category}
					<div class="category" use:styles={{ fsN, color }}>{category}</div>
					{#each products as item}
						{#if item.category === category}
							<div class="item_grid" use:styles={{ fsN, color }}>
								<div>{item.name}</div>
								<div class="align_center">{item.currency}</div>
								<div class="align_right">{item.price}</div>
								<div class="show_item" on:click={() => show_item(item.name)} on:keydown={() => show_item(item.name)} />
								<div class="link" on:click={() => delete_item(item.id)} on:keydown={() => delete_item(item.id)} />
								<div class="align_center">{item.stock}</div>
							</div>
						{/if}
					{/each}
					<div class="spacer" />
				{/each}
			{/if}
		</div>
	{/if}

	{#if showItem}
		{#await user}
			...preview loading
		{:then username}
			<div id="singleItem" style="width:100%;" transition:slide={{ duration: 500, delay: 600 }}>
				{#each products as item}
					{#if productName === item.name}
						<div class="single_item_menu_bar">
							<div class="title" use:styles={{ fsX, color }}>{item.name}</div>
						</div>

						<div class="sub_title" use:styles={{ fsN, color }}>short description</div>
						<div class="description" use:styles={{ fsN, color }}>{item.descshort}</div>
						<div class="sub_title" use:styles={{ fsN, color }}>long description</div>
						<div class="description" use:styles={{ fsN, color }}>{item.desclong}</div>
						<div class="sub_title" use:styles={{ fsN, color }}>image</div>
						<div class="description" use:styles={{ fsN, color }}>{item.image}</div>
						<div class="room_image">
							<img src="{url}/shop/thumbnail/{item.image}" alt="shop" />
						</div>

						<div class="item_row" use:styles={{ fsN, color }}>
							<div>stock</div>
							<div>{item.stock}</div>
							<div>price</div>
							<div>{item.price}</div>
							<div>currency</div>
							<div>{item.currency}</div>
						</div>
						<div class="button_container">
							<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click={() => update_item(item)}
								>amend</button
							>
							<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click={() => delete_item(item.id)}
								>delete</button
							>
							<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click={close_item}>close</button>
						</div>
						<div class="bookings_container" use:styles={{ color }}>
							<div class="bookings_title" use:styles={{ fsS }}>PROPERTIES</div>
							<div class="bookings_grid" use:styles={{ fsXS }}>
								{#each properties as prop}
									<div>{prop}</div>
								{/each}
							</div>
						</div>
					{/if}
				{/each}
			</div>
		{/await}
	{/if}
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

<style>
	button {
		width: 20%;
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: flex-end;
		margin-right: 0%;
		border-radius: 5px;
		font-size: var(--fsS);
		color: var(--buttonColor);
		box-shadow: 3px 3px 3px var(--shadow);
		background-color: transparent;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.button_container {
		margin-top: 30px;
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		margin-left: 5%;
		width: 100%;
		cursor: default;
		user-select: none;
	}
	.title {
		font-size: var(--fsX);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 0;
	}

	.category {
		font-size: var(--fsN);
		color: var(--color);
		font-weight: bold;
		margin-bottom: 1%;
		cursor: default;
		user-select: none;
	}

	.item_grid {
		display: grid;
		width: 80%;
		grid-template-columns: 40% 5% 15% 10% 5% 5%;
		font-size: var(--fsN);
		color: var(--color);
		grid-gap: 2%;
		cursor: default;
		user-select: none;
	}

	.single_item_menu_bar {
		display: flex;
		width: 85%;
		align-items: center;
		justify-content: space-between;
	}

	.sub_title,
	.description {
		display: block;
		width: 95%;
		color: var(--color);
		font-size: var(--fsN);
		margin-bottom: 20px;
	}

	.sub_title {
		text-decoration: underline;
	}

	.item_row {
		width: 95%;
		display: grid;
		grid-template-columns: 25% 75%;
		color: var(--color);
		font-size: var(--fsN);
		grid-row-gap: 15px;
	}

	.bookings_container {
		width: 100%;
		margin-top: 3%;
		color: var(--color);
	}

	.bookings_title {
		font-size: var(--fsS);
		text-decoration: underline;
		margin-bottom: 2%;
	}

	.bookings_grid {
		display: grid;
		width: 100%;
		grid-template-columns: repeat(3, 1fr);
		font-size: var(--fsXS);
	}

	.link,
	.show_item {
		cursor: pointer;
		width: 25px;
		height: 25px;
		background-repeat: no-repeat;
		background-size: cover;
		justify-self: flex-end;
	}
	.link {
		background-image: url('/images/bin.png');
	}
	.show_item {
		background-image: url('/images/icon_eye.png');
	}

	.align_center {
		justify-self: center;
	}

	.align_right {
		justify-self: flex-end;
	}

	.spacer {
		min-height: 1.5vh;
	}

	.message {
		font-size: var(--fsN);
	}

	.error {
		color: var(--colorError);
	}
</style>
